import React from "react";
import carQrCodeErrorImg from "../../../../assets/images/keyless-return/car-qr-code-error.svg";

export function FailQrCodeContent({ manualPlate, onManualPlateChange, t }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "16px",
      }}
    >
      <img
        src={carQrCodeErrorImg}
        alt="Falha ao ler QR Code"
        className="return-image"
      />

      <p
        style={{
          fontSize: "15px",
          margin: 0,
          color: "#333",
          lineHeight: "1.4",
        }}
      >
        {t("keylessReturnManualPlateInstruction")}
      </p>

      <div style={{ width: "100%", marginTop: "8px", marginBottom: "8px" }}>
        <label
          htmlFor="matricula"
          style={{
            display: "block",
            fontSize: "12px",
            color: "#666",
            marginBottom: "8px",
          }}
        >
          {t("keylessReturnManualPlateLabel")}
        </label>

        <input
          id="matricula"
          type="text"
          placeholder="AA-00-BB"
          value={manualPlate}
          onChange={(e) => onManualPlateChange(e.target.value)}
          style={{
            width: "100%",
            padding: "14px",
            fontSize: "18px",
            textAlign: "center",
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
            boxSizing: "border-box",
            outline: "none",
            color: "#333",
            fontWeight: "500",
            letterSpacing: "1px",
          }}
        />
      </div>
    </div>
  );
}
